import React, { useState } from 'react';
import { Field } from 'redux-form';
import { formatRut } from '../helpers/utils';
import { FormInput, FormNumber, FormSelect } from './';

const genders = [
  {
    name: 'Masculino',
    value: 'MALE',
  },
  {
    name: 'Femenino',
    value: 'FEMALE',
  },
];

const parentalOptions = [
  {
    name: 'Hijo / Hija',
    value: 'CHILDREN',
  },
  {
    name: 'Conyuge / Pareja',
    value: 'SPOUSE',
  },
];

interface IChargeProps {
  index: number;
  current: number;
}

export default function Plan(props: IChargeProps) {
  const { index, current } = props;
  const [name, setName] = useState('');
  const [paternal, setPaternal] = useState('');
  const [maternal, setMaternal] = useState('');
  const changeName = (event: any) => setName(event.target.value);
  const changePaternal = (event: any) => setPaternal(event.target.value);
  const changeMaternal = (event: any) => setMaternal(event.target.value);

  return (
    <div className={current === index ? "show" : "hide"}>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-relationship-${index}`}>
          Parentesco/Relación
        </label>
        <Field
          name={`charge-relationship-${index}`}
          placeholder="Selecciona.."
          component={FormSelect}
          options={parentalOptions}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-documentId-${index}`}>Rut</label>
        <Field
          name={`charge-documentId-${index}`}
          type="text"
          placeholder="Ej 12.345.678-9"
          component={FormInput}
          normalize={formatRut}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-name-${index}`}>Nombre</label>
        <Field
          name={`charge-name-${index}`}
          placeholder="Nombre"
          component={FormInput}
          onChange={changeName}
          value={name}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-paternal-${index}`}>Apellido Paterno</label>
        <Field
          name={`charge-paternal-${index}`}
          placeholder="Apellido paterno"
          component={FormInput}
          onChange={changePaternal}
          value={paternal}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-maternal-${index}`}>Apellido Materno</label>
        <Field
          name={`charge-maternal-${index}`}
          placeholder="Apellido materno"
          component={FormInput}
          onChange={changeMaternal}
          value={maternal}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-birthdate-${index}`}>
          Fecha de nacimiento
        </label>
        <Field
          name={`charge-birthdate-${index}`}
          placeholder="31-12-2000"
          inputFormat="##-##-####"
          mask={['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a']}
          component={FormNumber}
        />
      </div>
      <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto form-group">
        <label htmlFor={`charge-gender-${index}`}>Género</label>
        <Field
          name={`charge-gender-${index}`}
          placeholder="Selecciona.."
          component={FormSelect}
          options={genders}
        />
      </div>
    </div>
  );
}
